<template>
  <div>
    <div class="form-group" v-if="prefijo == enumeraciones.etiquetasDeHTML.Select">
      <select v-bind:id="idDelInput" v-model="idDelModelo" class="form-control" @change="cambiarDatos($event)">
        <option v-if="tipo.Id == enumeraciones.tiposDeSelect.Seleccione.Id" :value="tipo.Id">{{tipo.Nombre}} un Tramite</option>
        <option v-else-if="tipo.Id == enumeraciones.tiposDeSelect.Todos.Id" value="value">{{enumeraciones.tiposDeSelect.Todos.Nombre}} los Tramite</option>
        <option v-for="Municipio in Municipios" :key="Municipio.Abreviatura" :value="Municipio.Abreviatura">{{Municipio.Nombre}}</option>
      </select>
    </div>
  </div>
</template>
<script>
  import enumeraciones from '@/../static/js/enumeraciones'
  import catalogos from '@/../static/js/catalogos'
  import comun from '@/../static/js/comun'
  import api from '@/../static/js/api'
  import {mapActions} from 'vuex'
  import axios from 'axios'

  export default
  {
    data(){
      return {
        enumeraciones,
        comun,
        Municipios:[],
        idDelModelo: -1
      }
    },//Data
    props: {
      prefijo: Number,
      tipo: {
        Id: Number,
        Nombre: String
      },
      filtro: Boolean,
      idDelInput: String,
      valorDefinido: Number
    },//Props
    mounted() {
      if(this.valorDefinido == undefined || this.valorDefinido == null)
        this.idDelModelo = this.tipo.Id;
      else
        this.idDelModelo = this.valorDefinido;

      const parametros = {
        llave: this.idDelInput,
        valor: this.idDelModelo
      }
      this.$store.dispatch("A_TemisCivil_Catalogos_EstablecerMunicipio", { llave: this.idDelInput, valor: this.idDelModelo });
    },
    methods: {
    CargarCatalogoDeMunicipios(){
      let peticion = {
        EsPrueba: comun.EsPrueba,
        ConJuzgado: this.filtro
      }
      axios.post(api.conexion + api.TemisCivil.catalogos.Municipios, peticion)
          .then(respuesta => {
            if (respuesta.data.SiHayError) {
              comun.mensajeDeAlerta(respuesta.data.Error.Mensaje, null, null);
            } else {
              this.Municipios = respuesta.data._Municipios;
              //Seleccionar el primer municpio n_n
              this.idDelModelo = this.Municipios[0].Abreviatura;
              this.$store.dispatch("A_TemisCivil_Catalogos_EstablecerMunicipio", { llave: this.idDelInput, valor: this.idDelModelo });
              this.cambiaMunicipioInicial();
              return respuesta.data.Municipios;
            }
          }).catch(e => {
            console.log(e);
         });
    },//CargarCatalogoDeTramites
    cambiarDatos(evento) {
        this.idDelModelo = evento.target.value;
        this.$store.dispatch("A_TemisCivil_Catalogos_EstablecerMunicipio", { llave: this.idDelInput, valor: evento.target.value });
        this.$emit("valorParaElPadre", evento);
        },
    cambiaMunicipioInicial: function(){
        this.$store.dispatch("A_TemisCivil_Catalogos_EstablecerMunicipio", { llave: this.idDelInput, valor: this.idDelModelo});
        this.$emit("valorParaElPadre", this.idDelModelo);
      }
    },//Methods
    created() {
      this.CargarCatalogoDeMunicipios();
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/TemisCivil/Catalogos/Municipios.vue